
// 过滤器
import hxl from "../../plug/xlhuang"

//将时间戳转化为xxxx-xx-xx 或 xxxx/xx/xx
// @param value 时间戳
// @param f   符号 '/' 或 '-'
Vue.filter("dateInit",function (value, f) {
  return hxl.dateInit(value, f)
});

//保留几位小数
// * @param value 数字
// * @param num 保留几位
Vue.filter("keepDecimal",function (value, num) {
  return hxl.keepDecimal(value, num)
});

// * js截取字符串，中英文都能用
// * @param str：需要截取的字符串
// * @param len: 需要截取的长度
Vue.filter("resultShengLue",function (str,len) {
  return hxl.resultShengLue(str,len)
});

// 获取url属性
// * GetQueryString("id")// 传入参数名
Vue.filter("GetQueryString",function (name) {
  return hxl.GetQueryString(name)
});

//test ceshi
Vue.filter("test",function (val) {
  alert(JSON.stringify(val))
});







// WEBPACK FOOTER //
// ./src/api/filter/filter.js